import { CheckoutState } from 'b2b-apps/shop/checkout/redux/checkout/types';
import { hasCustomerReference } from 'b2b-apps/shop/checkout/utils/checkout';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { CheckoutDataType, UpdateCheckoutRequestBodyType } from 'b2b-common/core/checkout/Checkout.types';

const getState = (state: State): CheckoutState => state.checkout.checkout;

const getCheckout = (state: State): RemoteRecord<CheckoutDataType> => new RemoteRecord(getState(state));

const getCheckoutToken = (state: State): string | null => {
  const record = getCheckout(state);

  if (record.isLoaded && record.data?.token) {
    return record.data.token;
  }

  return null;
};

const getRequestData = (state: State): UpdateCheckoutRequestBodyType | null => {
  const record = getCheckout(state);

  if (!record.isLoaded || !record.data) {
    return null;
  }

  const data = record.data;

  return {
    confirmationEmail: data.addresses.addresses.delivery.email || '',
    licenceHolderData: data.licenseHolder.licenseHolder || '',
    mobileNumber: data.addresses.addresses.delivery.phoneNumber || '',
    payment: data.payment.selected || '',
    reference: data.references.order || '',
    remarks: data.references.sales || '',
    shipping: {
      deliveryDate: data.shipping.deliveryDate,
      dropShipmentTypes: {
        type: data.addresses.options.selected || '',
      },
      options: {
        type: data.shipping.options.selected,
      },
      type: data.shipping.selected,
    },
    shippingAddress: {
      displayName: data.addresses.addresses.delivery.name,
      contactPerson: data.addresses.addresses.delivery.contactPerson,
      street: data.addresses.addresses.delivery.street,
      streetaddition: data.addresses.addresses.delivery.streetAddition,
      zip: data.addresses.addresses.delivery.postCode,
      city: data.addresses.addresses.delivery.city,
      reference: hasCustomerReference(data.addresses.options.selected)
        ? data.references.customer || ''
        : '',
    },
  };
};

export { getCheckout, getCheckoutToken, getRequestData, getState };
